import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import { Item } from '@atlaskit/droplist';
import FooterDiv from '../styled/Footer';

var Footer = /*#__PURE__*/function (_PureComponent) {
  _inherits(Footer, _PureComponent);

  var _super = _createSuper(Footer);

  function Footer() {
    _classCallCheck(this, Footer);

    return _super.apply(this, arguments);
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          children = _this$props.children,
          elemBefore = _this$props.elemBefore,
          isFocused = _this$props.isFocused,
          onClick = _this$props.onClick,
          shouldHideSeparator = _this$props.shouldHideSeparator;
      return /*#__PURE__*/React.createElement(FooterDiv, {
        onClick: onClick,
        shouldHideSeparator: shouldHideSeparator
      }, /*#__PURE__*/React.createElement(Item, {
        appearance: appearance,
        elemBefore: elemBefore,
        isFocused: isFocused,
        type: "option"
      }, children));
    }
  }]);

  return Footer;
}(PureComponent);

export { Footer as default };